import FormActions from '@viking-eng/form-actions';
import PropTypes from 'prop-types';
import { Form } from 'redux-form';

import BookingActionModal from 'components/BookingActionModal/BookingActionModal';
import ConfirmEmailForm from 'components/ConfirmEmailForm/ConfirmEmailForm';

const SignInAs = ({ bookingId, cruiseName, error, handleSubmit, id, onClose, pristine, submitting, user }) => (
  <BookingActionModal id={id} title="Sign In As Guest" onClose={onClose}>
    {user && user.firstName && (
      <Form className="form confirm-email-form" name="sign-in-as" onSubmit={handleSubmit}>
        <ConfirmEmailForm bookingId={bookingId} cruiseName={cruiseName} user={user} />
        <FormActions
          alert={error}
          primaryButton={{
            disabled: pristine,
            loading: submitting,
            text: 'SUBMIT',
          }}
        />
      </Form>
    )}
  </BookingActionModal>
);

SignInAs.propTypes = {
  bookingId: PropTypes.string.isRequired,
  cruiseName: PropTypes.string.isRequired,
  error: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  id: PropTypes.string,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

SignInAs.defaultProps = {
  error: '',
  id: '',
};

export default SignInAs;
